export default __webpack_public_path__ + "static/media/boberLogo.28228f18.png";